"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRecommendationItemPrice = exports.getPriceRangeFromRecommendation = exports.adjustValue = void 0;
var _logger = require("../services/logger");
var _constants = require("./constants");
const ADJUSTMENT_GAP = 5;
const adjustValue = value => value % ADJUSTMENT_GAP === 0 ? value : value - value % ADJUSTMENT_GAP + ADJUSTMENT_GAP;
exports.adjustValue = adjustValue;
const getMatchingCharacteristics = (recommendationTypeChar, category, filters) => {
  const values = recommendationTypeChar.value;
  const hasMatchingFilter = values.some(itemCategory => filters.every(_ref => {
    let [filterKey, filterValue] = _ref;
    return itemCategory[filterKey] === filterValue;
  }));
  const hasMatchingCategory = values.some(itemCategory => itemCategory['@type'] === 'class' && itemCategory.id === category);
  return hasMatchingFilter && hasMatchingCategory;
};
const getRecommendationItemPrice = recommendation => (category, filters, configuredPriceType, numOfAdditionalPlans) => {
  const matchedRecommendationCategory = recommendation.recommendationItem.find(item => {
    const recommendationTypeChar = item.product.productCharacteristic.find(char => char.name === 'RecommendationType');
    if (!recommendationTypeChar) return false;
    return getMatchingCharacteristics(recommendationTypeChar, category, filters);
  });
  if (!matchedRecommendationCategory) return 0;
  if (numOfAdditionalPlans == 0 || numOfAdditionalPlans) {
    var _matchedRecommendatio, _matchedRecommendatio2;
    const listPrice = (_matchedRecommendatio = matchedRecommendationCategory.product.productPrice.find(p => p.priceType === _constants.PRICE_TYPES.LIST_PRICE)) === null || _matchedRecommendatio === void 0 ? void 0 : _matchedRecommendatio.price.taxIncludedAmount.value;
    const listAdditionalPlanPrice = (_matchedRecommendatio2 = matchedRecommendationCategory.product.productPrice.find(p => p.priceType === _constants.PRICE_TYPES.COMMERCE_ADDITIONAL_PLAN_PRICE)) === null || _matchedRecommendatio2 === void 0 ? void 0 : _matchedRecommendatio2.price.taxIncludedAmount.value;
    return parseInt(listAdditionalPlanPrice * numOfAdditionalPlans + listPrice);
  }
  const recommendationPrice = matchedRecommendationCategory.product.productPrice.filter(priceItem => priceItem.priceType === configuredPriceType).map(priceItem => priceItem.price.taxIncludedAmount.value).sort((a, b) => b - a)[0];
  return parseInt(recommendationPrice);
};
exports.getRecommendationItemPrice = getRecommendationItemPrice;
const getPriceRangeFromRecommendation = (recommendationResponse, categoryPriceTypes, numOfAdditionalPlans) => {
  var _categoryPriceTypes$f;
  const getItemPrice = getRecommendationItemPrice(recommendationResponse);
  const handsetCategory = _constants.PRODUCT_TYPES.HANDSET.toLowerCase();
  const planCategory = _constants.PRODUCT_TYPES.PLAN.toLowerCase();
  const handsetPriceType = categoryPriceTypes.find(configuredPriceType => configuredPriceType.category === handsetCategory).priceType;
  const planPriceType = (_categoryPriceTypes$f = categoryPriceTypes.find(configuredPriceType => configuredPriceType.category === planCategory)) === null || _categoryPriceTypes$f === void 0 ? void 0 : _categoryPriceTypes$f.priceType;
  const cheapestHandsetPrice = getItemPrice(handsetCategory, [['@type', 'price'], ['id', 'cheapest']], handsetPriceType);
  const cheapestPlanPrice = getItemPrice(planCategory, [['@type', 'price'], ['id', 'cheapest']], planPriceType, numOfAdditionalPlans);
  const recommendedHandsetPrice = getItemPrice(handsetCategory, [['@type', 'tier'], ['id', 'recommended']], handsetPriceType);
  const recommendedPlanPrice = getItemPrice(planCategory, [['@type', 'tier'], ['id', 'recommended']], planPriceType, numOfAdditionalPlans);
  const mostExpensiveHandsetPrice = getItemPrice(handsetCategory, [['@type', 'price'], ['id', 'most-expensive']], handsetPriceType);
  const mostExpensivePlanPrice = getItemPrice(planCategory, [['@type', 'price'], ['id', 'most-expensive']], planPriceType, numOfAdditionalPlans);

  // Adjust min - max values for ui friendly numbers
  // round min up to 5 and max up to 5
  // example: [176, 488] -> [180, 490]

  const minPlanValueAdjusted = adjustValue(cheapestPlanPrice);
  const maxPlanValueAdjusted = adjustValue(mostExpensivePlanPrice);
  const minHandsetValueAdjusted = adjustValue(cheapestHandsetPrice);
  const maxHandsetValueAdjusted = adjustValue(mostExpensiveHandsetPrice);
  _logger.Logger.info({
    segments: [_logger.Logger.LOGGER_SEGMENTS.UTILS]
  })('Budget', [`cheapestHandsetPrice: ${cheapestHandsetPrice}`, `cheapestPlanPrice: ${cheapestPlanPrice}`, `recommendedHandsetPrice: ${recommendedHandsetPrice}`, `recommendedPlanPrice: ${recommendedPlanPrice}`, `mostExpensiveHandsetPrice: ${mostExpensiveHandsetPrice}`, `mostExpensivePlanPrice: ${mostExpensivePlanPrice}`, `adjustedCheapestHandsetPrice: ${minPlanValueAdjusted}`, `adjustedCheapestPlanPrice: ${maxPlanValueAdjusted}`, `adjustedMostExpensiveHandsetPrice: ${minHandsetValueAdjusted}`, `adjustedMostExpensivePlanPrice: ${maxHandsetValueAdjusted}`]);
  return {
    minValue: cheapestHandsetPrice + cheapestPlanPrice,
    minPlanValueAdjusted,
    minHandsetValueAdjusted,
    recommendedPlanPrice,
    recommendedHandsetPrice,
    maxValue: mostExpensiveHandsetPrice + mostExpensivePlanPrice,
    maxPlanValueAdjusted,
    maxHandsetValueAdjusted
  };
};
exports.getPriceRangeFromRecommendation = getPriceRangeFromRecommendation;